import { render, staticRenderFns } from "./DealHistories.vue?vue&type=template&id=1937f8ba&"
import script from "./DealHistories.vue?vue&type=script&lang=ts&"
export * from "./DealHistories.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports